
import { PDFColors } from './types';

export const pdfColors: PDFColors = {
  text: [0, 0, 0],
  primary: [48, 92, 114],
  danger: [179, 57, 47],
  warning: [217, 119, 6],
  success: [39, 124, 69]
};
